module.exports = __webpack_public_path__ + "img/cmnd-front-3.e43d7699.png";